module.exports = __webpack_public_path__ + "img/1746687573745-WhatsApp Image 2025-05-08 at 14.56.43.jpeg.545fc428.webp";